import { Alert, Box, Typography } from "@mui/material";

import GaiaPagination from "~/modules/app/components/GaiaPagination";
import { usePagination } from "~/modules/app/hooks/usePagination";

import MapEditorFeatureList from "./MapEditorFeatureList";
import { useMapEditorFeatureListRouteData } from "./useMapEditorFeatureListRouteData";

export function MapEditorFeatureListRoute() {
    const { page, pageSize, onPageChange } = usePagination({ pageSize: 5 });
    const { features, featuresQueryInfo, error } = useMapEditorFeatureListRouteData({ pageSize, page });

    return (
        features &&
        featuresQueryInfo && (
            <Box paddingBottom={1}>
                {error && (
                    <Alert severity="error">
                        <Typography>{error.message}</Typography>
                    </Alert>
                )}
                <MapEditorFeatureList mapEditorFeatures={features} />
                <GaiaPagination
                    sx={{ display: "flex", justifyContent: "center" }}
                    page={page}
                    onPageChange={onPageChange}
                    total={featuresQueryInfo.paginationOption.total}
                    pageSize={pageSize}
                />
            </Box>
        )
    );
}
